import React from "react";
const Footer = () => {
    return (
        <footer>
            <h1>Academic Accord</h1>
            <p>&copy;Ewan Farr 2025</p>
            <ul>
                <li><a href="https://x.com" aria-label="Click on our X profile">
                    <img id="x-logo" src={"./images/X.png"} alt="X Social Media Platform Logo"/>
                </a></li>
            </ul>
        </footer>
    );
};
export default Footer;

